export default "https://cdn-static.gokick.com/assets/16eea26e4b02b6fb7531e57480884e04972270e8/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";